import React from 'react';

import useQRCodeGenerator from 'react-hook-qrcode-svg';

import {
  PDFDownloadLink,
  Document,
  View,
  Page,
  Text,
  StyleSheet,
  Font,
  Svg,
  Path,
} from '@react-pdf/renderer';

const QRCODE_SIZE = 256;
const QRCODE_LEVEL = 'Q';
const QRCODE_BORDER = 0;

Font.register({
  family: 'Poppins',
  fonts: [
    { src: '/admin/pdf-assets/poppins-regular.ttf' },
    { src: '/admin/pdf-assets/poppins-medium.ttf', fontWeight: 'medium' },
    { src: '/admin/pdf-assets/poppins-bold.ttf', fontWeight: 'bold' },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    padding: 20,
    paddingBottom: 16,
    alignItems: 'center',
    textAlign: 'center',
  },
  view: {
    alignItems: 'center',
    textAlign: 'center',
  },
  sku: {
    fontFamily: 'Poppins',
    fontWeight: 'medium',
    fontSize: 12,
    letterSpacing: 4,
    textTransform: 'uppercase',
    marginTop: 10,
  },
  name: {
    fontFamily: 'Poppins',
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 8,
    lineHeight: 1,
  },
  variation: { fontFamily: 'Poppins', fontSize: 8 },
  store: {
    fontFamily: 'Poppins',
    fontSize: 8,
    fontWeight: 'bold',
    lineHeigh: 1,
  },
});

export function WarehouseSticker({
  name,
  variation,
  sku,
  store,
  qrCode,
}) {
  const { path, viewBox } = useQRCodeGenerator(
    qrCode, QRCODE_LEVEL, QRCODE_BORDER
  );

  return (
    <Document>
      <Page size="A6" style={styles.page}>
        <View style={styles.view}>
          <Svg
            width={QRCODE_SIZE}
            height={QRCODE_SIZE}
            viewBox={viewBox}
          >
            <Path d={path} fill="black" />
          </Svg>
          <Text style={styles.sku}>{sku}</Text>
        </View>
        <View style={styles.view}>
          <Text style={styles.name}>{name}</Text>
          <Text style={styles.variation}>
            (
            {variation}
            )
          </Text>
        </View>
        <Text style={styles.store}>{store}</Text>
      </Page>
    </Document>
  );
}

export function DownloadWarehouseSticker({
  fileName,
  children,
  ...props
}) {
  return (
    <>
      <PDFDownloadLink
        document={<WarehouseSticker {...props} />}
        fileName={fileName}
      >
        {children}
      </PDFDownloadLink>
    </>
  );
}

export default WarehouseSticker;
